module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fnoindent1top"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Dedicated to "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Hulbert Burroughs")]), _vm._v(" in gratitude for his permission to write of Opar, that hidden city of “gold, and silver, ivory, and apes, and peacocks” and of the civilization which founded it.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54930cc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Dedication.vue
// module id = 72
// module chunks = 0